import { defaultObject } from "redux-store/selectors";
import { arrayToSelectOptions } from "util/select";

import {
  LOAD_PLAYER_VERSIONS_SUCCESS,
  UNLOAD_PLAYER_VERSIONS,
} from "./actions";

function playerVersionsReducer(state = defaultObject, action) {
  const { type, payload = {} } = action;
  const { data, message, response } = payload;

  switch (type) {
    case LOAD_PLAYER_VERSIONS_SUCCESS:
      return {
        data,
        message,
        statusCode: response.status,
        options: arrayToSelectOptions(data),
      };

    case UNLOAD_PLAYER_VERSIONS:
      return defaultObject;

    default:
      return state;
  }
}

export { playerVersionsReducer };
